export function setPersonalInfo(payload){
	return {
		type:'SET_PERSONAL_INFO',
		payload:payload
	}
}
export function setEducationDetails(payload){
	return {
		type:'SET_EDUCATION_DETAILS',
		payload:payload
	}
}
export function setInterests(payload){
	return {
		type:'SET_INTERESTS',
		payload:payload
	}
}
export function setLangKnown(payload){
	return {
		type:'SET_LANG_KNOWN',
		payload:payload
	}
}
export function setProjects(payload){
	return {
		type:'SET_PROJECTS',
		payload:payload
	}
}
export function setSkills(payload){
	return {
		type:'SET_SKILLS',
		payload:payload
	}
}
export function setWorkExp(payload){
	return {
		type:'SET_WORK_EXP',
		payload:payload
	}
}
export function setAdditionalInfo(payload){
	return {
		type:'SET_ADDITIONAL_INFO',
		payload:payload
	}
}

export function setIntro(payload){
	return {
		type:'SET_INTRO',
		payload:payload
	}
}